import debug from 'bows/dist/bows.min.js';

const log = debug("editor");

const btnNeedsSVG = document.querySelectorAll('.arrow-link-editor');
const btnSVG = `<svg width="16" height="16"><use xlink:href="#arrow-link" href="#arrow-link"></use></svg>`;

const btnNeedsSpan = document.querySelectorAll('[class*="btn--arrow"]');

const heading = document.querySelector('.page-header__title');

const wrapTable = document.querySelectorAll('.wysiwyg table');



function addBtnSVG() {
	btnNeedsSVG.forEach(element => {
		const html = '<span>' + element.innerHTML + '</span>' + btnSVG;
		element.innerHTML = html;
	});
}

function addBtnSpan() {
	btnNeedsSpan.forEach(element => {
		const html = '<span>' + element.innerHTML + '</span>';
		element.innerHTML = html;
	});
}

function addArcSpan() {
	if (!heading) { return; }
	let newarcHeading = heading.innerHTML.split('@');
	if (newarcHeading.length > 1) {
		heading.innerHTML = newarcHeading[0] + '<span>@' + newarcHeading[1] + '</span>';
	}
}

function addTableWrap() {
	wrapTable.forEach(element => {
		const html = '<div class="table-wrap">' + element.outerHTML + '</div>';
		element.outerHTML = html;
	});
}

export function init() {
	if (btnNeedsSVG !== null) {
		addBtnSVG();
	}
	if (btnNeedsSpan !== null) {
		addBtnSpan();
	}

	if (wrapTable !== null) {
		addTableWrap();
	}

	addArcSpan()

}

export default {
	init
};
